<template>
 <v-container fluid grid-list-md>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <span class="text-h4">Administratorske postavke</span>
      </v-col>
    </v-row>
      <v-row>
        <v-col cols="12" >
          <v-btn color="primary" @click="betons" class="ma-3">
            Betoni
          </v-btn>
          <v-btn color="primary" @click="betonkorisniks" class="ma-2">
            Betoni Korisnik
          </v-btn>
          <v-btn color="primary" @click="registerUser" class="ma-2">
            Registriraj novog korisnika
          </v-btn>
        </v-col>
    </v-row>

    <v-row no-gutters v-if="showBeton">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <Betoni />
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showTvrtka">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <BetoniTvrtke />
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showKorisnik">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <BetoniKorisnik />
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showObjekt">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <BetoniObjekt />
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showUserRegister">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <user-register />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import langEn from './mainDescEN'
import langHr from './mainDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import DocumentService from '@/services/DocumentService'
import Betoni from '@/components/Beton/BetonIndex'
import BetoniTvrtke from '@/components/Beton/BetonTvrtkaIndex'
import BetoniKorisnik from '@/components/Beton/BetonKorisnikIndex'
import BetoniObjekt from '@/components/Beton/BetonObjekatIndex'
import UserRegister from './Users/UserRegister.vue'

export default {
  name: 'appsettings',
  data () {
    return {
      menu: false,
      modal: false,
      msg: '',
      valid: true,
      account: { },
      error: null,
      localError: false,
      privGroups: [],
      lang: {},
      langC: {},
      saving: false,
      admin: false,
      showTerms: false,
      showBeton: false,
      showTvrtka: false,
      showKorisnik: false,
      showObjekt: false,
      showVehicle: false,
      showDocDesc: false,
      showUserRegister: false,
      mainQuery: {},
      userIsBeton: false,
    }
  },
  components: {
    Betoni,
    BetoniTvrtke,
    BetoniKorisnik,
    BetoniObjekt,
    UserRegister
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr;
      }
      if (this.$store.state.user.Admin) {
        this.admin = this.$store.state.user.Admin
      }
      this.userIsBeton = this.$store.state.user.beton ? this.$store.state.user.beton : false
  },
  methods: {
    termsofuse(){
      this.showTerms = !this.showTerms
    },
    registerUser () {
      this.showUserRegister = !this.showUserRegister
      this.showBeton = false
      this.showKorisnik = false
    },
    betons(){
      this.showBeton = !this.showBeton
      this.showUserRegister = false
      this.showKorisnik = false
    },
    betonkorisniks() {
      this.showKorisnik = !this.showKorisnik
      this.showUserRegister = false
      this.showBeton = false
    },
    vehicles() {
      this.showVehicle = !this.showVehicle
    },
    docdescs() {
      this.showDocDesc = !this.showDocDesc
    },
    async warehousemark () {
      try {
        await this.$router.push({
          name: 'warehousemark'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async warehouseuser () {
      try {
        await this.$router.push({
          name: 'warehouseuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async user () {
      try {
        await this.$router.push({
          name: 'user'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async bankaccount () {
      try {
        await this.$router.push({
          name: 'bankaccount'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async calendar () {
      try {
        await this.$router.push({
          name: 'calendar'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async company () {
      try {
        await this.$router.push({
          name: 'company'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companybusinessyear () {
      try {
        await this.$router.push({
          name: 'companybusinessyear'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companyuser () {
      try {
        await this.$router.push({
          name: 'companyuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async cardtype () {
      try {
        await this.$router.push({
          name: 'cardtype'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async updatedocdoc () {
      try {
        await DocumentService.updatedocdoc()
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },


  },
  computed: {
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
